<template>
  <BaseView>
    <div class="flex flex-col bg-blue-6 h-full w-full items-center py-[60px]">
      <div class="headline-1 text-center w-full max-w-5xl mx-[20px]" v-html="content.heading" />
      <p class="intro-1 mt-[40px] max-w-5xl text-center mx-[20px]" v-html="content.subHeading" />
      <br />

      <div class="flex flex-col justify-center items-center gap-10 mt-[40px]">
        <img
          :src="isUserOnMobile() ? OptimizeSuperChartMobile : OptimizeSuperChart"
          alt="Optimize super chart"
          class="w-full md:w-[830px] md:h-[336px]" />
        <div
          class="w-full grid gap-y-4 md:gap-y-0 md:flex flex-row-reverse justify-center items-center md:gap-2">
          <div
            class="button-4 bg-secondary text-white w-[300px] h-[22px] grid items-center text-center border border-grey-4 rounded-sm">
            With Advice your super can grow to $130,122
          </div>
          <div
            class="button-4 bg-blue-1 text-white w-[300px] h-[22px] grid items-center text-center border border-grey-4 rounded-sm">
            Without advice your super might stay at $70,000
          </div>
        </div>
      </div>
      <OtivoButton
        class="mt-[40px]"
        size="large"
        @click="createAccountWithModuleStream('personalInsurance')"
        >Help me optimise my super
      </OtivoButton>
      <div class="mt-10 fix-width-m-auto p-2 text-xs leading-4">
        The figures shown reflect the average uplift in net wealth until age 65 observed across the
        Otivo user base when recommendations are followed based on user-provided data and projected
        outcomes assuming the recommended strategies are implemented through to completion.
      </div>
    </div>
  </BaseView>
</template>

<script setup lang="ts">
import OtivoButton from '@/components/OtivoButton.vue'
import BaseView from '@/views/BaseView.vue'
import OptimizeSuperChart from '@/assets/img/optimze-super-chart.png'
import OptimizeSuperChartMobile from '@/assets/img/optimze-super-chart-mobile.png'
import createAccountWithModuleStream from '@/composables/createAccountWithModuleStream.ts'
import { isUserOnMobile } from '@/utilities.ts'

const content = {
  heading: `Are my super investments <span class="text-secondary"> optimised for me</span>?`,
  subHeading: `Did you know 95% of Otivo users receive advice about optimising their investment inside super? Thanks to our advice, people increase their retirement balance on average by<span class="text-blue-1 intro-2"> $138,645</span>.`,
}
</script>
